import { type GetSortingColId } from '@autone/ui';

import { type GetAssortmentProductsSortOption } from '../../../redux/assortment';

import { type ProductsTableColumnId } from './ProductsTable.types';

const sortableFieldToColumnIdMap: Record<
  GetSortingColId<GetAssortmentProductsSortOption>,
  ProductsTableColumnId
> = {
  product_id: 'product_name',
  lifetime_sales_units: 'total_sales_units',
  lifetime_sales_value: 'total_sales_value',
  store_inventory_units: 'store_units',
  warehouse_inventory_units: 'warehouse_units',
  first_sale_date: 'first_sale_date',
  latest_sale_date: 'latest_sale_date',
  warehouse_pending_from_production_units:
    'warehouse_pending_from_production_units',
};

export const sortableColumnToFieldIdMap = Object.fromEntries(
  Object.entries(sortableFieldToColumnIdMap).map(([k, v]) => [v, k]),
) as Record<
  ProductsTableColumnId,
  GetSortingColId<GetAssortmentProductsSortOption>
>;
